import Widget from 'app/components/common/Widget';
import { useStore } from 'app/context';
import { NachfolgePlanungVm } from 'app/stores/ui/nachfolgeplanung.ui.store';
import { formatDate } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import moment from 'moment';

interface AgenturInfoRowProps {
	label: string;
	value: string | number | undefined;
	highlight?: boolean;
}

const AgenturInfoRow = ({ label, value, highlight }: AgenturInfoRowProps) => (
	<tr className={highlight ? 'has-background-warning-light' : ''}>
		<td className="has-text-weight-semibold">{label}</td>
		<td>{value ?? '-'}</td>
	</tr>
);

interface AgtNachfolgePlanungAgenturInfoProps {
	agtId: number;
}

export const AgtNachfolgePlanungAgenturInfo = observer(({ agtId }: AgtNachfolgePlanungAgenturInfoProps) => {
	const { nachfolgeplanungUiStore } = useStore();
	const [vm, setVm] = useState<NachfolgePlanungVm | null>(null);

	useEffect(() => {
		nachfolgeplanungUiStore.load().then(() => {
			const found = nachfolgeplanungUiStore.items.find((item) => item.agtId === agtId);
			setVm(found || null);
		});
	}, [agtId, nachfolgeplanungUiStore]);

	if (!vm) {
		return null;
	}
	const agt = vm.agt;

	const personal = vm.personal;
	const inhaberAge = vm.inhaberAge;
	const yearsToRetirement = personal ? Math.max(0, 65 - inhaberAge) : null;
	const retirementDate = personal?.retirementDate;
	const agenturStartDate = agt.vtnrBegin;
	const agenturYears = agenturStartDate ? moment().diff(moment(agenturStartDate), 'years') : null;

	return (
		<Widget title="Agentur & Inhaber" disableCollapse={true} modifier="is-paddingless">
			<table className="table is-fullwidth is-narrow">
				<tbody>
					<AgenturInfoRow label="Inhaber Alter" value={inhaberAge ? `${inhaberAge} Jahre` : undefined} highlight={inhaberAge >= 55} />
					<AgenturInfoRow
						label="Jahre bis Rente (65)"
						value={yearsToRetirement !== null ? `${yearsToRetirement} Jahre` : undefined}
						highlight={yearsToRetirement !== null && yearsToRetirement <= 5}
					/>
					<AgenturInfoRow label="Voraussichtliches Renteneintrittsdatum" value={retirementDate ? formatDate(retirementDate) : undefined} />
					<AgenturInfoRow label="Agentur gegründet" value={agenturStartDate ? formatDate(agenturStartDate) : undefined} />
					<AgenturInfoRow label="Jahre als Agentur" value={agenturYears !== null ? `${agenturYears} Jahre` : undefined} />
					<AgenturInfoRow label="Vertreterkategorie" value={agt.vertKat?.name} />
					<AgenturInfoRow label="Provisionsmodell" value={agt.provsys?.name} />
				</tbody>
			</table>
		</Widget>
	);
});
